<template>
	<div>
		<div class="d-flex align-items-center mb-3">
			<div>
				<h1 class="page-header mb-0"><i class="fa-solid fa-ticket"></i> Kuponok</h1>
			</div>
			<div class="ms-auto">
				<button class="btn btn-success btn-rounded px-4 rounded-pill" v-b-modal.addCouponModal><i class="fa fa-plus fa-lg me-2 ms-n2 text-success-900"></i> Új kupon</button>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<panel title="Kuponok">
					<Loading v-if="!coupons" title="Kuponok betöltése"></Loading>
					<NoRecords v-else-if="coupons.length == 0" main_icon="fa-solid fa-ticket" value="false" title="Nincsenek kuponok" subtitle="adjon hozzá újat"></NoRecords>
					<vue-good-table v-else
						:columns="columns" 
						:rows="coupons" 
						:lineNumbers="true"
						:search-options="{ enabled: false, placeholder: 'Keresés...' }" 
						:pagination-options="{
							enabled: true, 
							position: 'bottom',

						}"
					>
						<template slot="table-row" slot-scope="props">
							<span v-if="props.column.field == 'actions'">
								<button v-if="props.row.deleted_at == null" @click="confirmDelete(props.row.id)" class="btn btn-danger btn-xs mx-1" title="delete"><i class="fa fa-trash"></i></button>
							</span>
							<span v-else-if="props.column.field == 'booking_id'">
								<span class="badge bg-danger" v-if="!props.row.booking_id">nincs felhasználva</span>
								<router-link v-else :to="'/bookings/'+props.row.booking_id" class="badge bg-primary">felhasználva a <b>#{{props.row.booking_id}}</b> foglalásban</router-link>
							</span>
							<span v-else>
								{{props.formattedRow[props.column.field]}}
							</span>
						</template>
					</vue-good-table>
				</panel>
			</div>
		</div>
		<b-modal id="addCouponModal" cancel-variant="default" @cancel="closeAddModal()" @ok="addCoupon" ok-title="Létrehozás" cancel-title="Mégse" :ok-disabled="loading" @shown="$refs.add_coupons_modal_name_input.focus()">
			<template slot="modal-header">
				<h4 class="modal-title">Új kupon</h4>
				<a class="btn-close" @click="closeAddModal()"></a>
			</template>
			<form @submit.prevent="addCoupon()" ref="coupon_modal_form" v-if="loading == false">
				<div class="form-group">
					<label class="form-label">Kuponkód:</label>
					<input ref="add_coupons_modal_name_input" class="form-control" type="text" v-model="coupon.name" required :class="{'is-invalid' : errors.name}">
					<div class="invalid-feedback d-block" v-if="errors.name">
							{{ errors.name[0] }}
					</div>
				</div>
				<div class="form-group mt-2">
					<label class="form-label">Vendégház:</label>
					<div class="input-group">
						<select class="form-control" v-model="coupon.guesthouse_id">
							<option value="">Összes vendégház</option>
							<option v-for="guesthouse in guesthouses" :value="guesthouse.id" :key="guesthouse.id">{{ guesthouse.name }}</option>
						</select>
					</div>
					<div class="invalid-feedback d-block" v-if="errors.discount_type">
							{{ errors.discount_type[0] }}
					</div>
				</div>
				<div class="form-group">
					<label class="form-label">Mennyiség (hány foglaláshoz használható fel a kupon):</label>
					<input class="form-control text-end" type="text" v-model="coupon.quantity" required :class="{'is-invalid' : errors.quantity}">
					<div class="invalid-feedback d-block" v-if="errors.quantity">
							{{ errors.quantity[0] }}
					</div>
				</div>
				<div class="form-group mt-2">
					<label class="form-label">Kedvezmény típusa:</label>
					<div class="input-group">
						<select class="form-control" v-model="coupon.discount_type" required :class="{'is-invalid' : errors.discount_type}">
							<option value="fixed">fix összegű</option>
							<option value="percent">százalékos</option>
						</select>
					</div>
					<div class="invalid-feedback d-block" v-if="errors.discount_type">
							{{ errors.discount_type[0] }}
					</div>
				</div>
				<div class="form-group mt-2">
					<label class="form-label">Kedvezmény:</label>
					<div class="input-group">						
						<input type="number" class="form-control text-end" v-model="coupon.value" required :class="{'is-invalid' : errors.value}">
						<span class="input-group-text" v-if="coupon.discount_type == 'fixed'">Ft</span>
						<span class="input-group-text" v-else>%</span>
					</div>
					<div class="invalid-feedback d-block" v-if="errors.value">
							{{ errors.value[0] }}
					</div>
				</div>
				<div class="form-group">
					<label class="form-label">Minimális vendégszám:</label>
					<input class="form-control text-end" type="text" v-model="coupon.persons" required :class="{'is-invalid' : errors.persons}">
					<div class="invalid-feedback d-block" v-if="errors.persons">
							{{ errors.persons[0] }}
					</div>
				</div>
				<div class="form-group">
					<label class="form-label">Minimális éjszaka:</label>
					<input class="form-control text-end" type="text" v-model="coupon.nights" required :class="{'is-invalid' : errors.nights}">
					<div class="invalid-feedback d-block" v-if="errors.nights">
							{{ errors.nights[0] }}
					</div>
				</div>
				<div class="form-group mt-2">
					<label class="form-label">Érvényes eddig:</label>
					<div class="input-group">
						<span class="input-group-text"><i class="fa fa-calendar"></i></span>
						<input type="date" class="form-control" v-model="coupon.valid_until" required :class="{'is-invalid' : errors.valid_until}" max="2050-12-31">
					</div>
					<div class="invalid-feedback d-block" v-if="errors.valid_until">
							{{ errors.valid_until[0] }}
					</div>
				</div>
				<div class="form-group mt-2">
					<label class="form-label">Kedvezményes időszak kezdete:</label>
					<div class="input-group">
						<span class="input-group-text"><i class="fa fa-calendar"></i></span>
						<input type="date" class="form-control" v-model="coupon.booking_from" required :class="{'is-invalid' : errors.booking_from}" max="2050-12-31">
					</div>
					<div class="invalid-feedback d-block" v-if="errors.booking_from">
							{{ errors.booking_from[0] }}
					</div>
				</div>
				<div class="form-group mt-2">
					<label class="form-label">Kedvezményes időszak vége:</label>
					<div class="input-group">
						<span class="input-group-text"><i class="fa fa-calendar"></i></span>
						<input type="date" class="form-control" v-model="coupon.booking_to" required :class="{'is-invalid' : errors.booking_to}" max="2050-12-31">
					</div>
					<div class="invalid-feedback d-block" v-if="errors.booking_to">
							{{ errors.booking_to[0] }}
					</div>
				</div>
				<button type="submit" class="d-none"></button>
			</form>
			<Loading v-if="loading == true" title="Létrehozás"></Loading>
		</b-modal>
	</div> 
</template>

<script>
	import Coupon from "../../apis/Coupon";
	import Guesthouse from "../../apis/Guesthouse";
	import Confirmation from "../../apis/Confirmation"; 

	export default {
		data() {
			return {
				columns: [
					{
						label: 'Kuponkód',
						field: 'name',
					},
					{
						label: 'Kedvezmény',
						field: 'formatted_value',
						tdClass: 'text-end'
					},
					{
						label: 'Vendégház',
						field: 'guesthouse_id',
						formatFn: this.guestHouseName
					}, 
					{
						label: 'Érvényesség',
						field: 'valid_until',
					},
					{
						label: 'Mennyiség',
						field: 'quantity',
						tdClass: 'text-end'
					},
					{
						label: 'Min.vendégszám',
						field: 'persons',
						tdClass: 'text-end'
					},
					{
						label: 'Min.éj',
						field: 'nights',
						tdClass: 'text-end'
					},
					{
						label: 'Időszak kezdete',
						field: 'booking_from'
					},
					{
						label: 'Időszak vége',
						field: 'booking_to'
					},
					{
						label: 'Foglalás',
						field: 'booking_id',
					},					
					{
						label: 'Műveletek',
						field: 'actions',
						sortable: false,
						thClass: 'text-end',
						tdClass: 'text-end',
					}  
				],
				coupons: false,
				guesthouses: false,
				coupon: {discount_type:'fixed',value:0,quantity:1,persons:1, nights:1,guesthouse_id:""},
				loading: false,
				roles: false,
				errors:[]
			}
		},
		created() {
			Coupon.index()
			.then(response => {
				this.coupons = response.data;
			});
			Guesthouse.index()
			.then(response => {
				this.guesthouses = response.data;
			});
		},
		methods: {
			closeAddModal(){
				this.coupon = {discount_type:'fixed',value:0,quantity:1,guesthouse_id:""};
				this.errors = [];
				this.$bvModal.hide('addCouponModal')
			},
			addCoupon(bvModalEvt){
				this.loading = true;
				if(bvModalEvt){ //ok gombra van csak event
					bvModalEvt.preventDefault();
				}
				this.errors = [];
				Coupon.store(this.coupon)
				.then(response => {
					this.coupons.push(response.data);
					this.closeAddModal();
				}).catch(error => {
					if(error.response.data.errors){
						this.errors = error.response.data.errors;
					}
				}).finally(() => {
					this.loading = false;
				})
			},
			confirmDelete(id){
				Confirmation.swalDelete().then(response => {
					if(response.isConfirmed === true){
						this.deleteCoupon(id);
					}
				})
			},
			deleteCoupon(id) {
				Coupon.delete(id)
					.then(() => {
						this.coupons.splice(this.coupons.map(n => n.id).indexOf(id),1);
					})
			},
			guestHouseName(guesthouseId){
				if(guesthouseId == null){
					return 'Összes';
				}
				else{
					return this.guesthouses.find(guesthouse => guesthouse.id === guesthouseId).name;
				}
			}
		},
	}
</script>

<style>
	
</style>